import { ApiBase } from '@/api/api'
import { makeGetRequest } from '@/api/fetchCalls'
import type { Packet } from '@/types/packet'

type PacketsResponse = Promise<{
  count: number
  results: Array<Packet>
}>

type PacketParams = {
  page?: number
  pageSize?: number
  search?: string
  simplified?: string
  without_disabled?: string
}

export async function getPackets(
  {
    page = 1,
    pageSize = 10,
    search = '',
    simplified = '',
    without_disabled = '',
  }: PacketParams = {},
  requestParams: { signal?: AbortSignal } = {}
): PacketsResponse {
  return await makeGetRequest(
    ApiBase +
      `/packets?page=${page}&page_size=${pageSize}&search=${search}&simplified=${simplified}&without_disabled=${without_disabled}`,
    requestParams
  )
}

export async function getPacket(id: string): Promise<Packet> {
  return await makeGetRequest(ApiBase + `/packets/${id}`)
}
